"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CustomerDetails_1 = __importDefault(require("./CustomerDetails"));
exports.default = CustomerDetails_1.default;
